module.exports = __webpack_public_path__ + "img/31.f106c863.svg";